
















import { Component, Prop, Vue } from 'vue-property-decorator';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
  faUniversity,
  faGavel,
  faDrawPolygon,
  faMapPin,
  faGlobe,
  faVectorSquare,
  faObjectUngroup,
  faFlagCheckered,
  faMapMarker,
  faEnvelope,
  faCrosshairs,
  faRoad,
  faQuestion,
  faMailBulk,
} from '@fortawesome/free-solid-svg-icons';
import { faCuttlefish } from '@fortawesome/free-brands-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';

@Component({
  components: { FontAwesomeIcon },
})
export default class ResultsSummary extends Vue {
  @Prop() private features!: GeoJSON.Feature[];

  constructor() {
    super();
    [
      faCuttlefish,
      faUniversity,
      faGavel,
      faDrawPolygon,
      faMapPin,
      faGlobe,
      faVectorSquare,
      faObjectUngroup,
      faFlagCheckered,
      faMapMarker,
      faEnvelope,
      faCrosshairs,
      faRoad,
      faQuestion,
    ].forEach((i) => library.add(i));
  }

  featureClicked(feature: GeoJSON.Feature, index: number) {
    this.$emit('feature-clicked', { feature, index });
  }

  // eslint-disable-next-line class-methods-use-this
  iconForLayer(layer: string) {
    switch (layer) {
      case 'locality':
        return faUniversity;
      case 'localadmin':
        return faGavel;
      case 'neighbourhood':
        return faDrawPolygon;
      case 'borough':
        return faMapPin;
      case 'county':
        return faCuttlefish;
      case 'macrocounty':
        return faGlobe;
      case 'region':
        return faVectorSquare;
      case 'macroregion':
        return faObjectUngroup;
      case 'country':
        return faFlagCheckered;
      case 'venue':
        return faMapMarker;
      case 'address':
        return faEnvelope;
      case 'mixed':
        return faCrosshairs;
      case 'street':
        return faRoad;
      case 'postalcode':
        return faMailBulk;
      default:
        return faQuestion;
    }
  }
}
